import * as React from "react";

import { usePdpAnalytics } from "../providers";
import { UpsellProductTile } from "./upsell-product-tile";
import { useEffect, useState } from "react";

/** The Fredhopper theme behind the section and the heading it renders under. */
export const UPSELL_LIST_ID = "pdp-stylewith";
export const UPSELL_LIST_NAME = "Customers Also Purchased";

export interface UpsellProduct {
  id: string
  price_lowest_au: number
  price_status_au: {}
  rrp_au: number
  base_colour_hex: {}
  label: {}
  colour_base_family: {}
  colour_base: {}
  filter_colour: {}
  description_long: string
  extended_description: string
  heading: {}
  itemcolour_ref: string
  itemdescription: string
  magento_id_product: string
  name: {}
  page_url: string
  url_prefix: string
  _imageurl: string
  _thumburl: string
  price_au: number
  price_label: {}
}

export const UpsellProduct: React.FunctionComponent<any> = ({ productId }: { productId: string}) => {
  const [themeDetails, setThemeDetails] = useState({} as any);
  const { analytics } = usePdpAnalytics();
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const channel = isMobile ? "mobile" : "desktop";

  const fetchThemeData = async (productId: string) => {
    try {
      const response = await fetch(
        `/datasource/fetch/product?magento_id_product=${productId}&channel=${channel}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const themeData = await response.json();
      setThemeDetails(themeData?.themes);
    } catch (e) {
      console.error("Error fetching theme data");
    }
  };

  useEffect(() => {
    if (productId) {
      fetchThemeData(productId);
    }
  }, []);

  const upsellItems: any[] = themeDetails?.pdp_stylewith?.items || [];
  const upsellIds = upsellItems
    .map((product: any) => String(product?.magento_id_product || ""))
    .filter(Boolean);
  const upsellSignature = upsellIds.join(",");
  useEffect(() => {
    if (upsellIds.length === 0) {
      return;
    }
    analytics.viewUpsellProducts({
      listId: UPSELL_LIST_ID,
      listName: UPSELL_LIST_NAME,
      productIds: upsellIds,
    });
  }, [upsellSignature, analytics]);

  const formatPrice = (price: any) => {
    let finalPrice: string = "";

    if (price) {
      const formattedPrice = parseFloat(price as any);
      if (!isNaN(formattedPrice)) {
        finalPrice = formattedPrice.toFixed(2);
      }
    }

    return finalPrice;
  };

  const getUrl = (product: UpsellProduct) => {
    let base_url = (window as any).authenticationPopup?.baseUrl || "";
    let url_prefix = product?.url_prefix || "";
    let page_url = product?.page_url || "";

    // Normalize slashes
    const joinUrls = (...parts: string[]) =>
      parts
        .filter(Boolean) // remove empty strings/nulls
        .map((part, i) => {
          if (i === 0) return part.replace(/\/+$/, ""); // remove trailing slashes for first part
          return part.replace(/^\/+|\/+$/g, ""); // remove leading & trailing slashes for others
        })
        .join("/");

    return joinUrls(base_url, url_prefix, page_url);
  }

  if (!themeDetails?.pdp_stylewith?.items?.length) return null;


  return (
      <>
        <div className="upsell-title"><h2>Customers Also Purchased</h2></div>
        <div className="upsell-product-collection">
          {themeDetails?.pdp_stylewith?.items.map((product: any, index: number) => {
            const priceBefore = product?.price ?? product?.price_au ?? product?.rrp;
            return (
                <div className="product">
                  <UpsellProductTile
                      url={getUrl(product)}
                      handleAction={() => {
                        analytics.clickUpsellProduct({
                          listId: UPSELL_LIST_ID,
                          listName: UPSELL_LIST_NAME,
                          productId: String(product?.magento_id_product || ""),
                          position: index + 1,
                        });
                      }}
                      image={product?._thumburl}
                      heading={Object.values(product?.heading)?.[0] as string}
                      priceLabel={Object.values(product?.price_label)?.[0] as string}
                      priceAfter={product?.special_price ? formatPrice(product?.special_price) : undefined}
                      priceBefore={formatPrice(priceBefore)}
                      rewardsPrice={formatPrice(product?.rewards_price)}
                  />
                </div>
            );
          })}
        </div>
      </>
  );
};
